import { enqueueSnackbar } from "notistack";
import { TbCalendarOff } from "react-icons/tb";

import CommonAlert from "@/components/CommonAlert";
import { useStartFreeDayMutation } from "@/requests/daily-status.queries";
import { useShiftShowStartFreeDayConfirmation } from "@/stores/use-shift";

function FreeDayDialog({ handleClose }: { handleClose: (val?: boolean, request?: boolean) => void }) {
    const { mutateAsync, isPending } = useStartFreeDayMutation();
    const showStartFreeDayConfirmation = useShiftShowStartFreeDayConfirmation();

    const handleConfirm = async () => {
        if (isPending) return;
        try {
            await mutateAsync();
            enqueueSnackbar("Haftalık izniniz başarılı şekilde başlatıldı.", { variant: "success" });

            handleClose(false, true);
        } catch (err) {
            console.error("positionSuccessCb error:", err);
        }
    };

    return (
        <CommonAlert
            open={showStartFreeDayConfirmation}
            loading={isPending}
            description="confirmations.startFreeDay"
            color="primary"
            onClose={() => handleClose(false)}
            handleConfirm={handleConfirm}
            html
            icon={TbCalendarOff}
        />
    );
}

export default FreeDayDialog;
